import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_loanrequests from './create_newaccounts';



function Admin_settings(){

  //const imgpath = 'http://127.0.0.1:8000/storage/';
  //const imgpath = 'https://pragatiprathmik.com/api/';
  //const imgpath = 'https://api.pragatiprathmik.com/storage/';
  //const imgpath = 'https://lightslategray-dog-143429.hostingersite.com/apidata/storage/';

  const imgpath = 'https://pragatiprathmik.businesssamadhan.in/storage/';

 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");
 const editId=sessionStorage.getItem("EditId00");

 
//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

 
 //Error Variable
 const[errorvar,seterrorvar] = useState();

 //FILTER VARIABLES
//filter_val
const[filterval,setfilterval]=useState(0);

 
//Variables
const[data,setData] = useState([]);//SetData Variable


useEffect(()=>{
   
    getData();
    getData1();
    
    },[])


    

//******************* GET BANKS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("crm-admin-get-banks-list", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,

   //Filters
   'Filter_val' :filterval,


   })
 .then((response) => {

   
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){

    seterrorvar("Validation error!");

  }

  //Data Violation
  if(response.data.error==102){ 
  
     //Setting Filter Violation Errors
     seterrorvar("Violation Error");


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET BANKS DATA FUNCTION END  ********************//


 
 //SETTING DATA VARIABLES
 const[disbursal_mode,setdisbursal_mode]=useState();const updatedisbursal_mode = (event) => { setdisbursal_mode(event.target.value);}; const[disbursal_mode_er,setdisbursal_mode_er]=useState();
 const[disbursal_bank_id,setdisbursal_bank_id]=useState();const updatedisbursal_bank_id = (event) => { setdisbursal_bank_id(event.target.value);}; const[disbursal_bank_id_er,setdisbursal_bank_id_er]=useState();
 const[disbursal_bank_name,setdisbursal_bank_name]=useState();const updatedisbursal_bank_name = (event) => { setdisbursal_bank_name(event.target.value);}; const[disbursal_bank_name_er,setdisbursal_bank_name_er]=useState();
 
 const[emi_mode,setemi_mode]=useState();const updateemi_mode = (event) => { setemi_mode(event.target.value);}; const[emi_mode_er,setemi_mode_er]=useState();
 const[emi_bank_id,setemi_bank_id]=useState();const updateemi_bank_id = (event) => { setemi_bank_id(event.target.value);}; const[emi_bank_id_er,setemi_bank_id_er]=useState();
 const[emi_bank_name,setemi_bank_name]=useState();const updateemi_bank_name = (event) => { setemi_bank_name(event.target.value);}; const[emi_bank_name_er,setemi_bank_name_er]=useState();
 
 const[closure_mode,setclosure_mode]=useState();const updateclosure_mode = (event) => { setclosure_mode(event.target.value);}; const[closure_mode_er,setclosure_mode_er]=useState();
 const[closure_bank_id,setclosure_bank_id]=useState();const updateclosure_bank_id = (event) => { setclosure_bank_id(event.target.value);}; const[closure_bank_id_er,setclosure_bank_id_er]=useState();
 const[closure_bank_name,setclosure_bank_name]=useState();const updateclosure_bank_name = (event) => { setclosure_bank_name(event.target.value);}; const[closure_bank_name_er,setclosure_bank_name_er]=useState();
  
 const[partpayment_mode,setpartpayment_mode]=useState();const updatepartpayment_mode = (event) => { setpartpayment_mode(event.target.value);}; const[partpayment_mode_er,setpartpayment_mode_er]=useState();
 const[partpayment_bank_id,setpartpayment_bank_id]=useState();const updatepartpayment_bank_id = (event) => { setpartpayment_bank_id(event.target.value);}; const[partpayment_bank_id_er,setpartpayment_bank_id_er]=useState();
 const[partpayment_bank_name,setpartpayment_bank_name]=useState();const updatepartpayment_bank_name = (event) => { setpartpayment_bank_name(event.target.value);}; const[partpayment_bank_name_er,setpartpayment_bank_name_er]=useState();
 
 const[pf_mode,setpf_mode]=useState();const updatepf_mode = (event) => { setpf_mode(event.target.value);}; const[pf_mode_er,setpf_mode_er]=useState();
 const[pf_bank_id,setpf_bank_id]=useState();const updatepf_bank_id = (event) => { setpf_bank_id(event.target.value);}; const[pf_bank_id_er,setpf_bank_id_er]=useState();
 const[pf_bank_name,setpf_bank_name]=useState();const updatepf_bank_name = (event) => { setpf_bank_name(event.target.value);}; const[pf_bank_name_er,setpf_bank_name_er]=useState();
 
 const[insurance_mode,setinsurance_mode]=useState();const updateinsurance_mode = (event) => { setinsurance_mode(event.target.value);}; const[insurance_mode_er,setinsurance_mode_er]=useState();
 const[insurance_bank_id,setinsurance_bank_id]=useState();const updateinsurance_bank_id = (event) => { setinsurance_bank_id(event.target.value);}; const[insurance_bank_id_er,setinsurance_bank_id_er]=useState();
 const[insurance_bank_name,setinsurance_bank_name]=useState();const updateinsurance_bank_name = (event) => { setinsurance_bank_name(event.target.value);}; const[insurance_bank_name_er,setinsurance_bank_name_er]=useState();
 

 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();

 
 //******************* GET SETTINGS DATA FUNCTION START  ********************//
function getData1(){
 

  //Checking if user loggedin
  //if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(editId>0)){
 
 axios.post("crm-settings-default-load", {
   Log_id:logid,
   Token:token,

   })
 .then((response) => {



  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");
     sessionStorage.removeItem("EditId00");
     window.location.replace("/");
  }

  //Data Not Found
  if((response.data.error)==103){  seterror_msg("Cannot Load Settings !");}

  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setdisbursal_mode(response.data.disbursal_mode);
   setdisbursal_bank_id(response.data.disbursal_bank_id);
   setdisbursal_bank_name(response.data.disbursal_bank_name);
   setemi_mode(response.data.emi_mode);
   setemi_bank_id(response.data.emi_bank_id);
   setemi_bank_name(response.data.emi_bank_name);
   setclosure_mode(response.data.closure_mode);
   setclosure_bank_id(response.data.closure_bank_id);
   setclosure_bank_name(response.data.closure_bank_name);
   setpartpayment_mode(response.data.partpayment_mode);
   setpartpayment_bank_id(response.data.partpayment_bank_id);
   setpartpayment_bank_name(response.data.partpayment_bank_name);
   setpf_mode(response.data.pf_mode);
   setpf_bank_id(response.data.pf_bank_id);
   setpf_bank_name(response.data.pf_bank_name);
   setinsurance_mode(response.data.insurance_mode);
   setinsurance_bank_id(response.data.insurance_bank_id);
   setinsurance_bank_name(response.data.insurance_bank_name);


  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){ seterror_msg("Validation error!"); }

  //Data Violation
  if(response.data.error==102){  seterror_msg("Violation Error"); }

 
 
 });
 
 /*}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");
   sessionStorage.removeItem("EditId00");
   window.location.replace("/");
 
  }*/
 
 }
  
 //******************* GET SETTINGS DATA FUNCTION END  ********************//


   
 
/*****************  UPDATE SETTINGS FUNCTION START  ******************/
function update_settings(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((logname!=null)||(logname!=" "))){


    //Setting Error Variables
    setdisbursal_mode_er(" "); setdisbursal_bank_id_er(" "); setdisbursal_bank_name_er(" ");
    setemi_mode_er(" "); setemi_bank_id_er(" "); setemi_bank_name_er(" ");
    setclosure_mode_er(" "); setclosure_bank_id_er(" "); setclosure_bank_name_er(" ");
    setpartpayment_mode_er(" "); setpartpayment_bank_id_er(" "); setpartpayment_bank_name_er(" ");
    setpf_mode_er(" "); setpf_bank_id_er(" "); setpf_bank_name_er(" ");
    setinsurance_mode_er(" "); setinsurance_bank_id_er(" "); setinsurance_bank_name_er(" ");
    seterror_msg(" ");
   
    
//Fetching Form Data
let noerror = 0;
const $disbursal_mode = document.getElementById("disbursal_mode").value; if($disbursal_mode==""){ setdisbursal_mode_er("Disbursal mode is required !");noerror = noerror+1; }//disbursal_mode
const $disbursal_bank_id = document.getElementById("disbursal_bank_id").value;// if($disbursal_bank_id==""){ setdisbursal_bank_id_er("Disbursal_bank_id is required !");noerror = noerror+1; }//disbursal_bank_id
const $emi_mode = document.getElementById("emi_mode").value; if($emi_mode==""){ setemi_mode_er("EMI mode is required !");noerror = noerror+1; }//emi_mode
const $emi_bank_id = document.getElementById("emi_bank_id").value;// if($emi_bank_id==""){ setemi_bank_id_er("emi_bank_id is required !");noerror = noerror+1; }//emi_bank_id
const $closure_mode = document.getElementById("closure_mode").value; if($closure_mode==""){ setclosure_mode_er("Closure mode is required !");noerror = noerror+1; }//closure_mode
const $closure_bank_id = document.getElementById("closure_bank_id").value;// if($closure_bank_id==""){ setclosure_bank_id_er("closure_bank_id is required !");noerror = noerror+1; }//closure_bank_id
const $partpayment_mode = document.getElementById("partpayment_mode").value; if($partpayment_mode==""){ setpartpayment_mode_er("Partpayment mode is required !");noerror = noerror+1; }//partpayment_mode
const $partpayment_bank_id = document.getElementById("partpayment_bank_id").value;// if($partpayment_bank_id==""){ setpartpayment_bank_id_er("partpayment_bank_id is required !");noerror = noerror+1; }//partpayment_bank_id
const $pf_mode = document.getElementById("pf_mode").value; if($pf_mode==""){ setpf_mode_er("PF mode is required !");noerror = noerror+1; }//pf_mode
const $pf_bank_id = document.getElementById("pf_bank_id").value;// if($pf_bank_id==""){ setpf_bank_id_er("pf_bank_id is required !");noerror = noerror+1; }//partpayment_bank_id
const $insurance_mode = document.getElementById("insurance_mode").value; if($insurance_mode==""){ setinsurance_mode_er("Insurance mode is required !");noerror = noerror+1; }//insurance_mode
const $insurance_bank_id = document.getElementById("insurance_bank_id").value;// if($insurance_bank_id==""){ setinsurance_bank_id_er("insurance_bank_id is required !");noerror = noerror+1; }//partpayment_bank_id


//No primary errors
if(noerror==0){


  //Sending Data through axios
  axios.post("crm-edit-setting", { 
  Log_id:logid,
  Token:token,
  Disbursal_mode:$disbursal_mode,
  Disbursal_bank_id:$disbursal_bank_id,
  EMI_mode:$emi_mode,
  EMI_bank_id:$emi_bank_id,
  Closure_mode:$closure_mode,
  Closure_bank_id:$closure_bank_id,
  Partpayment_mode:$partpayment_mode,
  Partpayment_bank_id:$partpayment_bank_id,
  PF_mode:$pf_mode,
  PF_bank_id:$pf_bank_id,
  Insurance_mode:$insurance_mode,
  Insurance_bank_id:$insurance_bank_id,

  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {


  //Validation Errors
  if(response.data.validatorerror){
  setdisbursal_mode_er(response.data.validatorerror.Disbursal_mode);
  setdisbursal_bank_id_er(response.data.validatorerror.Disbursal_bank_id);
  setemi_mode_er(response.data.validatorerror.EMI_mode);
  setemi_bank_id_er(response.data.validatorerror.EMI_bank_id);
  setclosure_mode_er(response.data.validatorerror.Closure_mode);
  setclosure_bank_id_er(response.data.validatorerror.Closure_bank_id);
  setpartpayment_mode_er(response.data.validatorerror.Partpayment_mode);
  setpartpayment_bank_id_er(response.data.validatorerror.Partpayment_bank_id);
  setpf_mode_er(response.data.validatorerror.PF_mode);
  setpf_bank_id_er(response.data.validatorerror.PF_bank_id);
  setinsurance_mode_er(response.data.validatorerror.Insurance_mode);
  setinsurance_bank_id_er(response.data.validatorerror.Insurance_bank_id);

  seterror_msg("Cannot Update Settings !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

  setdisbursal_mode_er(response.data.disbursal_mode_er);
  setdisbursal_bank_id_er(response.data.disbursal_bank_id_er);
  setemi_mode_er(response.data.emi_mode_er);
  setemi_bank_id_er(response.data.emi_bank_id_er);
  setclosure_mode_er(response.data.closure_mode_er);
  setclosure_bank_id_er(response.data.closure_bank_id_er);
  setpartpayment_mode_er(response.data.partpayment_mode_er);
  setpartpayment_bank_id_er(response.data.partpayment_bank_id_er);
  setpf_mode_er(response.data.pf_mode_er);
  setpf_bank_id_er(response.data.pf_bank_id_er);
  setinsurance_mode_er(response.data.insurance_mode_er);
  setinsurance_bank_id_er(response.data.insurance_bank_id_er);

  seterror_msg("Cannot Update Settings !");
  
  
  }
  
  //Branch Name or Branch Code Already Exists
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Update Settings !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** UPDATE SETTINGS FUNCTION END  ******************/

  

return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Admin Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

    <Sidebar /> 
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

              {/*  SUCCESS CARD START */}
                 <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Settings Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a href="/adminpanel-dashboard-settings"><button class="mt-3 btn btn-outline-success">Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/*  SUCCESS CARD END */}


          <div className="page-header flex-wrap">
            <div className="header-left">
        {/*}   <button style={{marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-outline-info" onClick={()=>{ window.location.replace("/adminpanel-dashboard-customers")}}>  Back </button>
         */}   </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">SETINGS</p>
                  </a>
                </div>
          {/*}     <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i>New Loan Request</button>  */}
              </div>
            </div>


                {/* ADMIN SETTINGS START */}
                <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Manage Settings</h4>
                    <div class="form-sample">
                      <p class="card-description">manage settings for all panels</p>
                      <code>{error_msg}</code>
                       
                       <h4>SET DEFAULT PAYMENT MODES</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Disbursal Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="disbursal_mode" value={disbursal_mode} onChange={updatedisbursal_mode}>
                            <option value="">-- select disbursal mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{disbursal_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Disbursal Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="disbursal_bank_id" value={disbursal_bank_id} onChange={updatedisbursal_bank_id}>
                            <option value={disbursal_bank_id}> {disbursal_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{disbursal_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>

                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">EMI Collection Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="emi_mode" value={emi_mode} onChange={updateemi_mode}>
                            <option value="">-- select emi mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{emi_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">EMI Collection Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="emi_bank_id" value={emi_bank_id} onChange={updateemi_bank_id}>
                            <option value={emi_bank_id}> {emi_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{emi_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>

                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Closure Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="closure_mode" value={closure_mode} onChange={updateclosure_mode}>
                            <option value="">-- select closure mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{closure_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Closure Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="closure_bank_id" value={closure_bank_id} onChange={updateclosure_bank_id}>
                            <option value={closure_bank_id}> {closure_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{closure_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>

                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Part Payment Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="partpayment_mode" value={partpayment_mode} onChange={updatepartpayment_mode}>
                            <option value="">-- select partpayment mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{partpayment_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Part Payment Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="partpayment_bank_id" value={partpayment_bank_id} onChange={updatepartpayment_bank_id}>
                            <option value={partpayment_bank_id}> {partpayment_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{partpayment_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>

                         <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">PF Collection Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="pf_mode" value={pf_mode} onChange={updatepf_mode}>
                            <option value="">-- select pf mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{pf_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">PF Collection Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="pf_bank_id" value={pf_bank_id} onChange={updatepf_bank_id}>
                            <option value={pf_bank_id}> {pf_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{pf_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                     
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Insurance Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="insurance_mode" value={insurance_mode} onChange={updateinsurance_mode}>
                            <option value="">-- select insurance mode --</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{insurance_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Insurance Bank</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="insurance_bank_id" value={insurance_bank_id} onChange={updateinsurance_bank_id}>
                            <option value={insurance_bank_id}> {insurance_bank_name} </option>
                            {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                            <option value={curElm.Bank_id}> {curElm.Bank_name} </option>
                            </>
                         )
                         }
					   
	                  		 )
                         }
                            </select>
                            <code>{insurance_bank_id_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                      
                        <button class="btn btn-lg btn-success" style={{fontWeight:"bold"}} onClick={update_settings}>Update Settings</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
                {/* ADMIN SETTINGS END */}

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Admin_settings;